import ListUserPannelSlider from "./listUserPannelSlider/ListUserPannelSlider"
import UploadUserPannelSlider from "./uploadUserPannelSlider/UploadUserPannelSlider"

function UserPannelSlider() {
    return (
        <>
            <UploadUserPannelSlider />
            <ListUserPannelSlider />
        </>
    )
}
export default UserPannelSlider